import IconButton from '@/components/IconButton';
import { CloseIcon } from '@/icons';
import { classes } from './utils';

export type TitleBarProps = {
  onClose: () => void;
};

export default function TitleBar({ onClose }: TitleBarProps) {
  return (
    <div className={classes.wrapper}>
      <h1 className={classes.title}>New Smile Simulation</h1>
      <div className={classes.actionsWrapper}>
        <IconButton
          className={classes.closeButton}
          title="Close"
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
}
